import { render, staticRenderFns } from "./homemain.vue?vue&type=template&id=1b98d91b&scoped=true&"
import script from "./homemain.vue?vue&type=script&lang=js&"
export * from "./homemain.vue?vue&type=script&lang=js&"
import style0 from "./homemain.vue?vue&type=style&index=0&id=1b98d91b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b98d91b",
  null
  
)

export default component.exports